import script from "./ListarCategoriasPlanos.vue?vue&type=script&setup=true&lang=js"
export * from "./ListarCategoriasPlanos.vue?vue&type=script&setup=true&lang=js"

import "./ListarCategoriasPlanos.vue?vue&type=style&index=0&id=336eb6bd&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-336eb6bd"]])

export default __exports__